import { FORM_STEP_OPTIONS, ROUTE_PATH } from 'common/constants/sm-constants';
import {
  GridMetaModel,
  Headers,
} from 'common/models/utility-models/meta-model';
import { CardFilter } from '../applicant-table/applicant-grid-meta.model';

export class BucketGridMetaModel extends GridMetaModel<Headers> {
  constructor() {
    super(
      'Back to Applicants',
      ROUTE_PATH.bucketGrid,
      ROUTE_PATH.applicantGrid,
      false,
      false,
      8,
      false,
      false,
      [],
      true,
      [],
      {
        isDownloadExcel: false,
        excelFileName: '',
        btnLabel: 'Download List',
        headers: [],
      },
      false,
      null,
      false,
      false,
      true,
      null,
      null,
      false,
      null,
      {
        isPreview: false,
        isPreviewType: 'VIDEO',
        isEnvUrl: false,
        linkKey: ['filePath'],
        previewName: '',
      },
      {
        isTabSwitch: false,
        label: '',
        isChecked: false,
      },
      false,
      true,
      true,
      null,
      false,
      {
        isExtraActions: true,
        btnLabel: '',
        selectOptions: [
          { key: 'Applied', value: 'Applied' },
          { key: 'Due Diligence', value: 'Due Diligence' },
          { key: 'Documentation', value: 'Documentation' },
          { key: 'Assessment', value: 'Assessment' },
          { key: 'Interview', value: 'Interview' },
          { key: 'Home Visit', value: 'Home Visit' },
          { key: 'Shortlisting', value: 'Shortlisting' },
          { key: 'Reject', value: 'Reject' },
        ],
        selectedValue: 'Applied',
        isPreviewBtn:false,
        previewBtnLabel:'',
        count:true
      },
      {
        isCheckboxEmit: false,
        emitKey: 'id',
        checkedKey: '',
        valueKey: '',
      }
    );
  }

  override initProperties() {
    const dataInfo = super.initProperties();

    const filters = new CardFilter();
    const stateFilerConstant = [];
     const studentDetails :ApplicantKeyDetails[] = []
      const matchedArray: any[] = [];
      const mapping:any=[];
      const batchOptions:any = [];
    dataInfo.filters = filters;
    dataInfo.stateFilerConstant = stateFilerConstant;
     dataInfo.studentDetails = studentDetails;
     dataInfo.matchedArray=matchedArray
     dataInfo.mapping = mapping;
     dataInfo.batchOptions=batchOptions;
    return dataInfo;
  }

  prepareHeaderList(): Headers[] {
    const headers: Headers[] = [];
    const orgname = new Headers('Full Name', 'orgname', false, false, 'text');
    const Total = new Headers(
      'Total Score',
      'Total',
      false,
      false,
      'text'
    );
    const AllIndiaRank = new Headers(
      'AIR',
      'AllIndiaRank',
      false,
      false,
      'text'
    );
    const StateRank = new Headers(
      'State Rank',
      'StateRank',
      false,
      false,
      'text'
    );
    const ZoneRank = new Headers(
      'Zonal Rank',
      'ZoneRank',
      false,
      false,
      'text'
    );

    const score10 = new Headers('10th', 'score10', false, false, 'text');
    const score12 = new Headers('12th', 'score12', false, false, 'text');
    const mobileNumber = new Headers(
      'Contact No.',
      'mobileNumber',
      false,
      true,
      'text'
    );
    const callCount = new Headers(
      'Call Count',
      'callCount',
      false,
      false,
      'text',
      // '0',
      // null,
      // null,
      // null,
      // false
    );

    headers.push(orgname);
    headers.push(Total);
    headers.push(AllIndiaRank);
    headers.push(StateRank);
    headers.push(ZoneRank);
    headers.push(score10);
    headers.push(score12);
    headers.push(mobileNumber);
    headers.push(callCount);

    //   headers.push(viewApplicantsList)
    return headers;
  }
}


export class ApplicantKeyDetails {
  labelsAndKeys: Array<{ label: string; key: string; value: any }> = [
    // { label: 'Full Name', key: 'firstName', value: '' },
    { label: 'First Name', key: 'firstName', value: '' },
    { label: 'Middle Name', key: 'middleName', value: '' },
    { label: 'Last Name', key: 'lastName', value: '' },
    { label: 'Gender', key: 'gender', value: '' },
    { label: 'Age', key: 'age', value: '' },
    { label: 'Phone', key: 'mobileNumber', value: '' },
    { label: 'Alternate', key: 'landlineNumber', value: '' },
    { label: 'Email ID', key: 'email', value: '' },
    { label: 'Alternate Email', key: 'alternativeEmail', value: '' },
    { label: 'City/Town', key: 'city', value: '' },
    { label: 'State/UT of domicile', key: 'stateName', value: '' },
    { label: 'District', key: 'district', value: '' },
    { label: 'Family Annual Income', key: 'familyAnnualIncome', value: '' },
    { label: 'Father\'s Full Name', key: 'fatherName', value: '' },
    { label: 'Father\'s Profession', key: 'fatherProfession', value: '' },
    { label: 'Mother\'s Full Name', key: 'motherName', value: '' },
    { label: 'Mother\'s Profession', key: 'motherProfession', value: '' },
    { label: '10th Std Score', key: 'score10', value: '' },
    { label: '12th Std Score', key: 'score12', value: '' },
    { label: 'Physics', key: 'physicsMarks', value: '' },
    { label: 'Chemistry', key: 'chemistryMarks', value: '' },
    { label: 'Mathematics', key: 'mathematicsMarks', value: '' },
    { label: 'JEE/CET Score', key: 'jeeScore', value: '' },
    { label: 'Engineering College Name', key: 'instituteName', value: '' },
    { label: 'Institute Type', key: 'instituteType', value: '' },
    { label: 'Institute Phone', key: 'instituteContact', value: '' },
    { label: 'Institute Address', key: 'instituteAddress', value: '' },
    { label: 'College State', key: 'collageStateName', value: '' },
    { label: 'Branch', key: 'branch_name', value: '' },
    { label: 'First Year Fees', key: 'firstYearFees', value: '' },
    { label: 'Other Scholarship', key: 'anyScholarship', value: '' },
    { label: 'Offering Institute', key: 'offeringInstitute', value: '' },
    { label: 'Scholarship Name', key: 'anyScholarshipName', value: '' },
    { label: 'Scholarship Amount', key: 'scholarshipAmount', value: '' },
    { label: 'Marks Gained', key: 'assessmentMarks', value: '' },
    { label: 'Total Marks', key: 'assessmentMaxMarks', value: '' },
    { label: 'Interview Score', key: 'interviewScore', value: '' },
    { label: 'Interview Feedback', key: 'interviewFeedback', value: '' }
  ];
}


export class passApplicantPayload
{
  id: (string | number)[];
  currentStatus: number | null;
  batch_id?: number; 
}